import { useEffect, useMemo } from 'react';
import { useMarketConfig } from '~/app/market-config';
import { groupItemsByGroupAndFamily } from '~/app/utils/group-items';
import { useConfigurator } from '~/graphql/hooks/use-configurator';
import { useSelectedStandardEquipmentLazyQuery } from '~/graphql/hooks/use-configured-car-queries';

export function useSelectedStandardEquipment(triggerDataLoad: boolean) {
	const { carIdentifier } = useConfigurator();
	const { config } = useMarketConfig();
	const { fetchStandartEquipmentData, selectedStandardEquipment, isLoading } =
		useSelectedStandardEquipmentLazyQuery(carIdentifier);

	useEffect(() => {
		if (triggerDataLoad) {
			fetchStandartEquipmentData();
		}
	}, [triggerDataLoad]);

	const standardEquipment = selectedStandardEquipment?.configuredCar?.catalog?.features?.data || [];

	const groupedItems = useMemo(
		() => groupItemsByGroupAndFamily(standardEquipment?.filter((feature) => feature.group.id !== 'Weitere')),
		[selectedStandardEquipment, config],
	);

	return {
		standardEquipment,
		groupedItems,
		isLoading,
	};
}
